import * as propTypes from 'prop-types';
import * as React from 'react';
import { CTA } from '../../components/CTA';
import { __ } from '../../helpers/TranslationService';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';

interface IProps {
    onClick: () => void;
    isFormValid?: boolean;
    testSelectorName?: string;
    className?: string;
    buttonText?: string;
    fontSize?: number;
    wrapper?: any;
    tracking?: any;
}

export class SubmitButton extends React.Component<IProps, unknown> {
    static contextTypes = {
        track: propTypes.func,
    };

    onClick = () => {
        this.props.onClick();
        if (this.context.track && this.props.isFormValid) {
            eventTracker.track({
                ...this.props.tracking,
                event: 'click',
            });
        }
    };

    render() {
        const buttonText =
            this.props.buttonText === undefined ? __('Send', 'dreamlines') : this.props.buttonText;

        const fontSize = this.props.fontSize ? { fontSize: this.props.fontSize } : {};
        return (
            <div style={this.props.wrapper} className={this.props.className}>
                <CTA
                    onClick={this.onClick}
                    testSelectorName={this.props.testSelectorName}
                    wrapperStyle={fontSize}
                >
                    <span>{buttonText}</span>
                </CTA>
            </div>
        );
    }
}
